import React, { useEffect, useState } from "react";
import { UpdateSettingsDTO } from "../../../models/settings/settings.request";
import { useNotification } from "../../toster-notification/NotificationContext";
import { settingsService } from "../../../services/settingsService";
import { GetSettingsInfoDTO } from "../../../models/settings/settings.response";
import { Switch } from "@mui/material";
import e from "express";

const SettingsPage: React.FC = () => {

    const [settings, setSettings] = useState<GetSettingsInfoDTO | null>(null);
    const [settingsId, setSettingsId] = useState<string>("");
    const [appName, setAppName] = useState<string>("");
    const [appNameError, setAppNameError] = useState<string>("");
    const [emailSupport, setEmailSupport] = useState<string>("");
    const [emailSupportError, setEmailSupportError] = useState<string>("");
    const [phoneSupport, setPhoneSupport] = useState<string>("");
    const [phoneSupportError, setPhoneSupportError] = useState<string>("");
    const [membershipWarningDays, setMembershipWarningDays] = useState<number>(0);
    const [membershipWarningDaysError, setMembershipWarningDaysError] = useState<string>("");
    const [maintenanceModeOn, setMaintenanceModeOn] = useState<boolean>(false);
    const [autoEmailNotification, setAutoEmailNotification] = useState<boolean>(false);

    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        setLoading(true);
        try {
            const response = await settingsService.getSettingsInfo();

            if (response.data) {
                setSettings(response.data);
                setSettingsId(response.data.id);
                setAppName(response.data.appName);
                setEmailSupport(response.data.emailSupport);
                setPhoneSupport(response.data.phoneSupport);
                setMembershipWarningDays(response.data.membershipWarningDays);
                setMaintenanceModeOn(response.data.maintenanceModeOn);
                setAutoEmailNotification(response.data.autoEmailNotification);
            } else {
                notify("error", "No settings data found.");
            }
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                notify("error", error.response.data.message || "Failed to fetch settings.");
            } else {
                notify("error", "Failed to fetch settings.");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSaveSettings = async () => {

        setAppNameError("");
        setEmailSupportError("");
        setPhoneSupportError("");
        setMembershipWarningDaysError("");

        let validated = true;

        if (!appName || appName.trim() === "") {
            setAppNameError("Naziv sajta je obavezan.");
            validated = false;
        }

        if (membershipWarningDays < 0) {
            setMembershipWarningDaysError("Broj dana ne može biti negativan.");
            validated = false;
        }

        if(!emailSupport && emailSupport.trim() === "") {
            setEmailSupportError("Unesite email podrške");
            validated = false;
        }

        if(!phoneSupport && phoneSupport.trim() === "") {
            setPhoneSupportError("Unesite telefon podrške");
            validated = false;
        }

        if(emailSupport && emailSupport.trim() !== "") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(emailSupport)) {
                setEmailSupportError("Unesite validnu email adresu.");
                validated = false;
            }
        }

        if(phoneSupport && phoneSupport.trim() !== "") {
            const phoneRegex = /^\+?[0-9\s\-()]{7,}$/;
            if (!phoneRegex.test(phoneSupport)) {
                setPhoneSupportError("Unesite validan broj telefona.");
                validated = false;
            }
        }

        if (!validated) {
            return;
        }


        setLoading(true);

        try {
            const response = await settingsService.updateSettings({
                id: settingsId,
                appName,
                emailSupport,
                phoneSupport,
                membershipWarningDays,
                maintenanceModeOn,
                autoEmailNotification
            });

            if (response.data && response.message) {
                notify("success", response.message);
            }
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                notify("error", error.response.data.message || "Failed to update settings.");
            } else {
                notify("error", "Failed to update settings.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="sa-settings-section">
            <div className="w-layout-blockcontainer container w-container">
                <div className="sttings-content-wrapper">
                    <div className="header-div">
                        <div>
                            <h2 className="heading-3">Sistemska Podešavanja</h2>
                            <div className="text-block">
                                Globalna podešavanja i konfiguracija sistema<br />
                            </div>
                        </div>
                        <div className="header-button-div">
                            <div className="button-primary " onClick={() => handleSaveSettings()}>
                                <img loading="lazy" src="https://cdn.prod.website-files.com/6919e066813f7ba31cee91ac/691f8f5a2064e8c571d2cb0e_diskette%20(1).png" alt="" className="button-image" />
                                <div className="button-text">Sačuvaj podešavanja</div>
                            </div>
                        </div>
                    </div>
                    <div className="admin-settings-box-div sa-settings-block">
                        <div className="list-header-info">
                            <div className="list-header-title">Opšta Podešavanja</div>
                            <div className="list-header-description">
                                Osnovne informacije o sistemu<br />
                            </div>
                        </div>
                        <div className="info-settings-div">
                            <div className="form-block-4 w-form">
                                <form className="form-4">

                                    <div className="div-block-5">
                                        <label >Naziv sajta*</label>
                                        <input className="form-input basic-info w-input" placeholder="Naziv sajta" type="text"
                                            value={appName}
                                            onChange={(e) => setAppName(e.target.value)}
                                        />
                                        <div className="error-text">{appNameError}</div>
                                    </div>

                                    <div className="div-block-5">
                                        <label >Email podrske</label>
                                        <input className="form-input basic-info w-input" placeholder="Email podrške" type="text"
                                            value={emailSupport}
                                            onChange={(e) => setEmailSupport(e.target.value)}
                                        />
                                        <div className="error-text">{emailSupportError}</div>
                                    </div>

                                    <div className="div-block-5">
                                        <label >Telefon podrške</label>
                                        <input className="form-input basic-info w-input" placeholder="Telefon podrške" type="text"
                                            value={phoneSupport}
                                            onChange={(e) => setPhoneSupport(e.target.value)}
                                        />
                                        <div className="error-text">{phoneSupportError}</div>
                                    </div>

                                    <div className="div-block-12">
                                        <div className="div-block-13">
                                            <label >Režim Održavanja</label>
                                            <div className="description-text">Privremeno onemogući pristup svim korisnicima</div>
                                        </div>
                                        <div>
                                            <Switch 
                                                checked={maintenanceModeOn}
                                                onChange={(e) => setMaintenanceModeOn(e.target.checked)}
                                            />
                                        </div>
                                    </div>
                                    
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="admin-settings-box-div sa-settings-block">
                        <div className="list-header-info">
                            <div className="list-header-title">Notifikacije</div>
                            <div className="list-header-description">
                                Podešavanja za obaveštenja i notifikacije<br />
                            </div>
                        </div>
                        <div className="info-settings-div">
                            <div className="form-block-4 w-form">
                                <form className="form-4">
                                    <div className="div-block-12">
                                        <div className="div-block-13">
                                            <label >Email notifikacije</label>
                                            <div className="description-text">Šalji email obaveštenja administratorima</div>
                                        </div>
                                        <div>
                                            <Switch 
                                                checked={autoEmailNotification}
                                                onChange={(e) => setAutoEmailNotification(e.target.checked)}
                                            />
                                        </div>
                                    </div>
                                    <div className="div-block-5">
                                        <label >Upozorenje za istek članarine (dana pre)</label>
                                        <input className="form-input basic-info w-input" placeholder="Broj dana pre isteka članarine" type="number"
                                            value={membershipWarningDays}
                                            onChange={(e) => setMembershipWarningDays(Number(e.target.value) > 0 ? Number(e.target.value) : 0)}
                                        />
                                        <div className="error-text">{membershipWarningDaysError}</div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SettingsPage;